import React, { Fragment, useEffect } from "react";
import Grid from "@mui/material/Grid";
import CTAContent from "../components/dashboard/cta-content";
import PaymentsContent from "../components/dashboard/payments-content";
import ActivityContent from "../components/dashboard/activity-content";
import MessagesContent from "../components/dashboard/messages-content";
import UnassignedLeadsContent from "../components/dashboard/unassigned-leads-content";
import IOSAppUsersContent from "../components/dashboard/ios-app-users-content";
import AcceptedDeclinedLeadsContent from "../components/dashboard/accepted-declined-leads-content";
import { useAuth0 } from "@auth0/auth0-react";

const Dashboard = () => {
  useEffect(() => {
    document.title = "Dashboard | evoJets HQ";
  }, []);

  const { user } = useAuth0();

  const userRoles = user && user["https://new.evojets.com/roles"];
  const isDutySales = user && user["https://new.evojets.com/appMetadata"]?.isDutySales;

  const superAdminOrAd = userRoles.some(function (role) {
    return "Super Admin" === role || "Account Director" === role;
  });

  return (
    <Fragment>
      <Grid id="dashboard" container spacing={2}>
        {isDutySales && (
          <AcceptedDeclinedLeadsContent/>
        )}

        {superAdminOrAd && (
          <Grid item sm={12} lg={6}>
            <UnassignedLeadsContent/>
          </Grid>
        )}

        <Grid item sm={12} lg={6}>
          <IOSAppUsersContent/>
        </Grid>

        {!superAdminOrAd && (
          <Grid item lg={6} style={{
            display: {
              sm: "none",
            },
          }}/>
        )}
        <Grid item sm={12} lg={6}>
          <CTAContent type="open"/>
        </Grid>
        <Grid item sm={12} lg={6}>
          <CTAContent type="resolved"/>
        </Grid>
        <Grid item sm={12} lg={6}>
          <PaymentsContent type="clientPaymentHistory"/>
        </Grid>
        <Grid item sm={12} lg={6}>
          <PaymentsContent type="operatorPaymentHistory"/>
        </Grid>
        <Grid item sm={12} lg={6}>
          <ActivityContent type="contract"/>
        </Grid>
        <Grid item sm={12} lg={6}>
          <ActivityContent type="ofr"/>
        </Grid>
        <Grid item sm={12} lg={6}>
          <MessagesContent type="messages"/>
        </Grid>
        <Grid item sm={12} lg={6}>
          <MessagesContent type="appMessages"/>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default Dashboard;
